import { useOutletContext } from 'react-router'
import { ApplicationsOutletContext } from '../../../layouts/ApplicationsRootLayout'
import { ApplicationsGrid, ApplicationsGridLoading } from './ApplicationsGrid'
import { ApplicationsTable } from './ApplicationsTable'
import { Suspense } from 'react'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent/DataTableLoading'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'

export function ApplicationsHome() {
  const { view } = useOutletContext<ApplicationsOutletContext>()

  return (
    <div className="px-5">
      {/* <PageHeader title="Applications">
        <GridTableToggle value={view} onChange={setView} />
      </PageHeader> */}
      <QueryErrorBoundary errorMessage="Failed to fetch applications">
        <TablePageContainer fullHeight>
          {view === 'table' && (
            <Suspense fallback={<DataTableLoading />}>
              <ApplicationsTable />
            </Suspense>
          )}
          {view === 'cards' && (
            <Suspense fallback={<ApplicationsGridLoading />}>
              <ApplicationsGrid />
            </Suspense>
          )}
        </TablePageContainer>
      </QueryErrorBoundary>
    </div>
  )
}
